import { render, staticRenderFns } from "./FichaTecnicaModais.vue?vue&type=template&id=261bdaa2"
import script from "./FichaTecnicaModais.vue?vue&type=script&lang=js"
export * from "./FichaTecnicaModais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports